// extracted by mini-css-extract-plugin
export default {"padding":"ContactUsDetail_padding__G+GYL"};